import { render, staticRenderFns } from "./newbies.vue?vue&type=template&id=f68d5f40&"
import script from "./newbies.vue?vue&type=script&lang=js&"
export * from "./newbies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports